import React from 'react'
import PropTypes from 'prop-types'
import {createComponent} from '@republic/react-foundation'
import Particle from '../Particle/index'

export default (
    createComponent(
        'Divider',
        {
            propTypes: {
                color: PropTypes.string
            }
        },
        ({color, ...props}) => (
            <Particle className={'bits-divider'} {...props} border={{width: [1,0,0], color: color || 'black'}} />
        )))
